import { useQueryClient } from "@tanstack/react-query";
import { HOME_DOMAIN, HOME_TASK_LIST_ENDPOINT } from "api/homeApi";
import { CustomResponseFormat } from "api/instance";
import { TaskType } from "api/taskApi";
import { applyDoneToList } from "./applyDoneToList";

// 활동지(task) 홈 리스트 쿼리 캐시에 done 을 낙관적으로 선반영.
// queryKey 는 patientId/userId 변형이 있을 수 있어 setQueriesData(2요소 prefix) 로 fuzzy 매칭.
export default function useOptimisticHomeListDone() {
  const queryClient = useQueryClient();

  const markTaskDone = (taskKey: string) => {
    const nowIso = new Date().toISOString();
    queryClient.setQueriesData<CustomResponseFormat<TaskType[]>>(
      [HOME_DOMAIN, HOME_TASK_LIST_ENDPOINT],
      (old) => applyDoneToList(old, (t) => t.taskKey === taskKey, nowIso)
    );
  };

  return { markTaskDone };
}
